import { CModelRepo as cModelRepo } from './cmodel.repo';


class CModelController implements angular.IOnInit {
  static $inject = ["cModelRepo","$rootScope","$mdDialog","$state"];


  /** @ngInject */
  constructor(private cModelRepo: cModelRepo,private $rootScope: angular.IRootScopeService,private $mdDialog: angular.material.IDialogService,
   private $state: angular.ui.IStateService) {
  }

  $onInit() {
    var that = this;
  }

  public cancel() {
    this.$state.go("root.cmodel");
    return;
  }

  public newCModel() {
    const tempScope = this.$rootScope.$new(true);

    this.$mdDialog.show({
      template: '<md-dialog flex="30"><c-model-dialog></c-model-dialog></md-dialog>',
      scope: tempScope
    }).then((result) => {
      if (result) {
        alert("New C Model created!");
      }
    });
  }
}

export const cModel: angular.IComponentOptions = {
  template: require('./cmodel.html'),
  controller: CModelController
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.ts